import { FC } from 'react';

const FirstPageUI: FC = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-y-6">
      <div className="tw-flex tw-flex-col ">
        <h1 className="tw-text-xl tw-font-sora tw-font-bold tw-text-neutral-950">
          Students land on a personalized path
        </h1>
        <p className="tw-text-base tw-font-atkinson tw-m-0 tw-text-neutral-700">
          The homepage shows one path per unit — a sequence of skills leading to a grade-level target. The path{' '}
          <span className="tw-font-bold">begins where the individual student is ready to start,</span> marks their
          current skill, and adjusts to what they&apos;re ready for next.
        </p>
      </div>
      <img
        src="./learn-experience-modal-1.png"
        alt="learn-experience-modal-1"
        className="lg:tw-w-full tw-h-auto tw-object-contain tw-w-[50%]"
      />
      <div className="tw-flex tw-flex-col tw-px-6 tw-py-4 tw-rounded-2xl tw-bg-indigo-50 tw-gap-y-2 ">
        <span className="tw-px-4 tw-py-1 tw-w-max tw-rounded-md tw-border tw-solid tw-border-indigo-400 tw-bg-indigo-500 tw-uppercase tw-font-bold tw-font-atkinson tw-text-xs tw-text-white">
          KEEP STUDENTS ON TRACK
        </span>
        <p className="tw-m-0 tw-font-bold tw-font-atkinson tw-text-base tw-text-indigo-950">
          We recommend students complete <span className="tw-text-indigo-600">2 skills per week</span> because evidence
          shows this leads to impactful progress
        </p>
      </div>
    </div>
  );
};

export default FirstPageUI;
